module.exports = __webpack_public_path__ + "media/site_templates/www.waterleakrepair.com.au/images/our_services_2-4d3a54c438ec870b29bd69367a0f4d97.jpg";